import { render, staticRenderFns } from "./assessStatistics.vue?vue&type=template&id=6741d44e&scoped=true&"
import script from "./assessStatistics.vue?vue&type=script&lang=js&"
export * from "./assessStatistics.vue?vue&type=script&lang=js&"
import style0 from "./assessStatistics.vue?vue&type=style&index=0&id=6741d44e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6741d44e",
  null
  
)

export default component.exports